module.exports = __webpack_public_path__ + "static/media/home.6151e109.jpg";